import { TextField } from "@material-ui/core";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { OrderVerticalType } from "@saleor/types/globalTypes";
import * as React from "react";

import { OpsLateDeliveryList } from "../initialData";

interface OpsLateDeliveryProps {
  lateDeliveryReason: { value: string; otherReason: string };
  setLateDeliveryReason: (reason: {
    value: string;
    otherReason: string;
  }) => void;
  verticalType: OrderVerticalType;
}

const OpsLateDelivery: React.FC<OpsLateDeliveryProps> = props => {
  const { lateDeliveryReason, setLateDeliveryReason, verticalType } = props;

  const handleOnChange = (value: string) => {
    setLateDeliveryReason({
      otherReason: "",
      value
    });
  };

  const handleOnChangeOtherReason = (otherReason: string) => {
    setLateDeliveryReason({
      otherReason,
      value: "OTHERS"
    });
  };

  const getSelectValue = value => {
    if (!OpsLateDeliveryList.find(e => e.value === value)) {
      return "OTHERS";
    } else {
      return value;
    }
  };

  return (
    <>
      <h3
        id="txtAdminFulfillmentAssignRiderDialogOpsAdminReasonForLateDelivery"
        style={{
          margin: "0px",
          marginBottom: "6px",
          marginLeft: "5px"
        }}
      >
        <span>{"Ops Admin Reason for Late Delivery"}</span>
      </h3>
      <SingleSelectField
        choices={OpsLateDeliveryList.filter(e => e.type.includes(verticalType))}
        onChange={e => handleOnChange(e.target.value)}
        value={getSelectValue(lateDeliveryReason.value)}
        label={"Select Ops Admin Reason for Late Delivery"}
        name="dropdownAdminFulfillmentAssignRiderDialogSelectFieldLateDelivery"
      />
      {lateDeliveryReason.value === "OTHERS" ||
      !OpsLateDeliveryList.find(e => e.value === lateDeliveryReason.value) ? (
        <TextField
          id="txtAdminFulfillmentAssignRiderDialogOpsLateDeliveryReason"
          style={{
            marginTop: "2px"
          }}
          label="Specify other reason here"
          multiline
          fullWidth
          onChange={e => handleOnChangeOtherReason(e.target.value)}
          value={lateDeliveryReason.otherReason}
          rows={6}
        />
      ) : null}
    </>
  );
};

export default OpsLateDelivery;
